import moment from 'moment-timezone';
import { zoneAbbrev } from './local_time';

const IST = 'Asia/Kolkata';
const FORMAT = 'D MMM YYYY, h:mm A';

const stamp = (m: moment.Moment, zone: string): string =>
  `${m.clone().tz(zone).format(FORMAT)} ${zoneAbbrev(zone, m.valueOf()) || zone}`;

// "Created: 21 Oct 2026, 2:14 PM IST · 4:44 AM EDT (student)"; the student's
// clock is added only when their zone is known and its offset differs from IST.
export function createdTimeLine(
  createdAtIso: string | null | undefined,
  studentZone: string | null | undefined
): string {
  if (!createdAtIso) return '';
  const m = moment.utc(createdAtIso);
  if (!m.isValid()) return '';
  const ist = stamp(m, IST);
  const zone = studentZone && moment.tz.zone(studentZone) ? studentZone : '';
  if (!zone || m.clone().tz(zone).utcOffset() === m.clone().tz(IST).utcOffset()) {
    return `Created: ${ist}`;
  }
  const local = m.clone().tz(zone);
  const sameDay = local.format('YYYY-MM-DD') === m.clone().tz(IST).format('YYYY-MM-DD');
  const localText = sameDay ? local.format('h:mm A') : local.format(FORMAT);
  return `Created: ${ist} · ${localText} ${zoneAbbrev(zone, m.valueOf()) || zone} (student)`;
}
